import { render, staticRenderFns } from "./articleOverview.vue?vue&type=template&id=72619a25&scoped=true&"
import script from "./articleOverview.vue?vue&type=script&lang=js&"
export * from "./articleOverview.vue?vue&type=script&lang=js&"
import style0 from "./articleOverview.vue?vue&type=style&index=0&id=72619a25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72619a25",
  null
  
)

export default component.exports